import { render, staticRenderFns } from "./resignation_detail.vue?vue&type=template&id=10dc759d&scoped=true&"
import script from "./resignation_detail.vue?vue&type=script&lang=js&"
export * from "./resignation_detail.vue?vue&type=script&lang=js&"
import style0 from "./resignation_detail.vue?vue&type=style&index=0&id=10dc759d&prod&lang=scss&"
import style1 from "./resignation_detail.vue?vue&type=style&index=1&id=10dc759d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dc759d",
  null
  
)

export default component.exports